module.exports = __webpack_public_path__ + "static/media/kopila_put_book_to_bag.e424e100.png";